<script>

    import appConfig from "@/app.config";
    import { required } from "vuelidate/lib/validators";
    import { customerMethods, customerListComputed, layoutMethods, pushNotificationMethods } from "@/state/helpers";
    import Swal from 'sweetalert2';

/**
 * Profile Details component
 */
export default {
    page: {
        title: "Profile Details",
        meta: [
        {
            name: "description",
            content: appConfig.description,
        },
        ],
    },
    data() {
        return {
            title: "Profile Details",
            items: [
                {
                    text: "Peddlr",
                },
                {
                    text: "Profile Details",
                    active: true,
                },
            ],
            visible: false,
            index: 0,
            selected: 'Pending',
            options: [
                { value: 'Pending', text: 'Please select an option' },
                { value: 'Accept', text: 'Accept', },
                { value: 'Reject', text: 'Reject' },
            ],
            verification: false,
            userId: 0,
            isIDVisible: false,
            idDetails: {
                firstName: "",
                middleName: "",
                lastName: "",
                idType: "",
                idNumber: "",
                desc: ""
            },
            isSubmitted: false,
            showCreateModal: false,
            idDetailsValidation: {
                firstName: false,
                middleName: false,
                lastName: false,
                idType: false,
                idNumber: false,
                desc: false
            },
            isUpdateKYC : false,
            formExitChecker: {
                firstName: "",
                middleName: "",
                lastName: "",
                idType: "",
                idNumber: "",
                desc: ""
            },
            userProfileImg: '@/assets/images/users/avatar-1.jpg'
        };
    },
    computed:{
        ...customerListComputed
    },
    validations: {
        idDetails: {
            firstName: {required},
            middleName: {required},
            lastName: {required},
            idType: {required},
            idNumber: {required},
            desc: {required}
        },
    },
    mounted() {
        this.userId = this.$route.params.id
        this.changeTitle({title: 'Merchant Detail'});
        this.changeBreadCrumb({
                breadCrumbs: [
                    { text: 'Peddlr', to: { name: 'Home'} },
                    { text: 'Merchant List', to: { name: 'Subscriber'} },
                    { text: 'Merchant Detail', to: { name: 'Merchant Detail'} }
                ]
            });
        this.getSubsDetails()
    },
    methods: {
        ...layoutMethods,
        ...customerMethods,
        ...pushNotificationMethods,
        async getSubsDetails() {
            await this.getSubscriberDetails({
                id: this.userId,
            })
            //this will set the img index
            try {
                if(this.subscriberDetails.kyc_details.kyc_history){
                    var img_i = 2;
                    for(let data of this.subscriberDetails.kyc_details.kyc_history){
                        if(data.action == "upload" || data.action == "re-upload"){
                            data.id_index = img_i;
                            img_i++;
                            data.selfie_index = img_i;
                            img_i++;
                        }
                    }
                    if(Object.prototype.hasOwnProperty.call(this.subscriberDetails, 'kyc_details')){
                        if(Object.prototype.hasOwnProperty.call(this.subscriberDetails.kyc_details, 'selfie')){
                            // subscriberDetails.kyc_details.selfie
                            this.userProfileImg = this.subscriberDetails.kyc_details.selfie;
                        }
                    }
                }   
                console.log(">> image src:",this.subscriberDetails.kyc_details.kyc_history)
            } catch (error) {
                console.log(">> KYC err:", error)
            }
            if(this.haveKYC('status','manual')){
                this.evaluateKyc()
            }
        },
        showImg(index) {
            this.index = index;
            this.visible = true;
        },
        verifyKYC(action) {
            var process_action = false;
            switch (action) {
                case "reject":
                    this.idDetailsValidation.firstName = false;
                    this.idDetailsValidation.middleName = false;
                    this.idDetailsValidation.lastName = false;
                    this.idDetailsValidation.idType = false;
                    this.idDetailsValidation.idNumber = false;
                    this.idDetailsValidation.desc = this.idDetails.desc == "" || this.idDetails.desc == null ?true:false; //this will validate if the desc if empty
                    process_action = !(this.idDetailsValidation.desc)
                    // console.log("><><><><>",this.idDetailsValidation.desc, this.idDetails.desc, (this.idDetails.desc == "" || this.idDetails.desc == null));
                    break;
                case "verified":
                    this.idDetailsValidation.firstName = this.idDetails.firstName.length == 0 || this.idDetails.firstName == "" ?true:false; //this will validate if the value if empty
                    this.idDetailsValidation.middleName = this.idDetails.middleName.length == 0 || this.idDetails.middleName == "" ?true:false; //this will validate if the value if empty
                    this.idDetailsValidation.lastName = this.idDetails.lastName.length == 0 || this.idDetails.lastName == "" ?true:false; //this will validate if the value if empty
                    this.idDetailsValidation.idType = this.idDetails.idType == null || this.idDetails.idType == "" ?true:false; //this will validate if the value if empty
                    this.idDetailsValidation.idNumber = this.idDetails.idNumber == null || this.idDetails.idNumber == "" ?true:false; //this will validate if the value if empty
                    this.idDetailsValidation.desc = false;
                    process_action = this.idDetailsValidation.idNumber == false && this.idDetailsValidation.idType == false && this.idDetailsValidation.lastName == false && this.idDetailsValidation.middleName == false && this.idDetailsValidation.firstName == false
                    break;
                default:
                    break;
            }
            var word = action == "verified" ? "Verify" : "Reject"
            Swal.fire({
                title: 'Are you sure?',//' you want to '+word+':  '+this.idDetails.firstName+' '+this.idDetails.lastName+'?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '##804997',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, '+word+' it!'
                }).then((result) => {
                if (result.isConfirmed) {
                    this.isSubmitted = true
                    // this.$v.$touch();

                    // if (!this.$v.idDetails.$invalid) {
                    if (process_action) {
                        this.actionKYC({
                            userId: this.userId,
                            username: this.subscriberDetails.cogUserName,
                            action: action,
                            description: this.idDetails.desc,
                            idDetails: {
                                firstName: this.idDetails.firstName,
                                middleName: this.idDetails.middleName,
                                lastName: this.idDetails.lastName,
                                idType: this.idDetails.idType,
                                idNumber: this.idDetails.idNumber
                            }
                        })
                        .then(async ()=>{
                            this.verification = false
                            this.getSubsDetails()
                            this.formExitChecker = this.idDetails;
                            // this.$alertify.success("KYC successfully verified!");   
                            Swal.fire(
                                (word == "Verify"?"Verified":"Rejected")+'!',
                                'KYC has been '+(word == "Verify"?"verified":"rejected")+'.',
                                'success'
                            )    
                            var push_notification_message = (word == "Verify"? "Congratulations! your account is now verified.":"Sorry! Your KYC Application has been rejected.");
                            await this.pushMobileNotification({
                                "title": "KYC Verification",
                                "to": this.subscriberDetails.businessId,
                                "content": push_notification_message
                            })
                            .then(function(res){
                                console.log(">> push notification res:", res);
                            })
                            .catch(function(e){
                                console.log(">> push notification err:", e);
                            })
                        })
                        .catch(function(e) {
                            console.log(e)
                            this.$alertify.error("something went wrong!");       

                            return;
                        });
                    }
                }
            })

        },
        haveKYC(type, value) {
            let havekyc =  this.subscriberDetails.kyc_details ? true : false
            if (!type) return havekyc
            else if (type == 'status')  return havekyc ? this.subscriberDetails.kyc_details.kyc_status.status == value ? true : false : false
            else if (type == 'result')  return havekyc ? this.subscriberDetails.kyc_details.kyc_result !== undefined ? true : false : false
        },
        formatEpochDate(date) {
            var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
            d.setUTCSeconds(date)
            return d;
        },
        evaluateKyc(is_update = false){// this will put the data from id details to form
            try {
                this.verification = !this.verification
                this.idDetails.firstName = this.subscriberDetails.kyc_details.kyc_result.idDetails.firstName
                this.idDetails.middleName = this.subscriberDetails.kyc_details.kyc_result.idDetails.middleName
                this.idDetails.lastName = this.subscriberDetails.kyc_details.kyc_result.idDetails.lastName
                this.idDetails.idType = this.subscriberDetails.kyc_details.kyc_result.idDetails.idType

                this.formExitChecker.firstName = this.subscriberDetails.kyc_details.kyc_result.idDetails.firstName
                this.formExitChecker.middleName = this.subscriberDetails.kyc_details.kyc_result.idDetails.middleName
                this.formExitChecker.lastName = this.subscriberDetails.kyc_details.kyc_result.idDetails.lastName
                this.formExitChecker.idType = this.subscriberDetails.kyc_details.kyc_result.idDetails.idType
                try {
                    this.idDetails.idNumber = this.subscriberDetails.kyc_details.kyc_result.idDetails.idNumber
                    this.idDetails.desc = Object.prototype.hasOwnProperty.call(this.subscriberDetails.kyc_details.kyc_status, "remarks") ? this.subscriberDetails.kyc_details.kyc_status.remarks : this.subscriberDetails.kyc_details.kyc_status.description
                    this.formExitChecker.idNumber = this.subscriberDetails.kyc_details.kyc_result.idDetails.idNumber
                    this.formExitChecker.desc = Object.prototype.hasOwnProperty.call(this.subscriberDetails.kyc_details.kyc_status, "remarks") ? this.subscriberDetails.kyc_details.kyc_status.remarks : this.subscriberDetails.kyc_details.kyc_status.description
                } catch (error) {
                    console.log(">> err assigning var:", error)
                }
                if(is_update){
                    this.isUpdateKYC = true

                } 
                return true;
            } catch (error) {
                console.log(">> ERR:",error);
            }
        },
        async showCreateModalFunction(){
            this.$bvModal.show('bv-modal-kyc-history')
        },
        closeModal(modal){
            this.$bvModal.hide(modal)
        },
        updateKYC() {
            var process_action = false;
            this.idDetailsValidation.firstName = this.idDetails.firstName.length == 0 || this.idDetails.firstName == "" ?true:false; //this will validate if the value if empty
            this.idDetailsValidation.middleName = this.idDetails.middleName.length == 0 || this.idDetails.middleName == "" ?true:false; //this will validate if the value if empty
            this.idDetailsValidation.lastName = this.idDetails.lastName.length == 0 || this.idDetails.lastName == "" ?true:false; //this will validate if the value if empty
            process_action = this.idDetailsValidation.lastName == false && this.idDetailsValidation.middleName == false && this.idDetailsValidation.firstName == false
            Swal.fire({
                title: 'Are you sure?',//' you want to '+word+':  '+this.idDetails.firstName+' '+this.idDetails.lastName+'?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '##804997',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Update it!'
                }).then((result) => {
                if (result.isConfirmed) {
                    this.isSubmitted = true
                    // this.$v.$touch();

                    // if (!this.$v.idDetails.$invalid) {
                    if (process_action) {
                        this.updateVerifiedKYC({
                            userId: this.userId,
                            username: this.subscriberDetails.cogUserName,
                            idDetails: {
                                firstName: this.idDetails.firstName,
                                middleName: this.idDetails.middleName,
                                lastName: this.idDetails.lastName
                            }
                        })
                        .then(()=>{
                            this.verification = false
                            this.getSubsDetails()
                            this.formExitChecker = this.idDetails;
                            // this.$alertify.success("KYC successfully verified!");   
                            Swal.fire(
                                'Updated!',
                                'KYC has been updated.',
                                'success'
                            )    
                        })
                        .catch(function(e) {
                            console.log(e)
                            this.$alertify.error("something went wrong!");       

                            return;
                        });
                    }else{
                        Swal.fire(
                            'Oops!',
                            'Please complete the form.',
                            'warning'
                        )    
                    }
                }
            })

        },
        leaveform(next, in_page = false){
            if(JSON.stringify(this.idDetails) == JSON.stringify(this.formExitChecker) && in_page){
                this.verification = !this.verification
                return;
            }
            Swal.fire({
                title: 'Are you sure?',
                text: "you want to leave this page?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '##804997',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.isConfirmed) {
                    if(in_page){
                        this.verification = !this.verification
                    }else{
                        next();
                    }
                }else{
                    return;
                }
            })
        },
        isEmpty(value){
            return (
            // null or undefined
            (typeof value == "undefined") || 
            (value == undefined) ||
            (value == null) ||
            (value === "") ||
            // has length and it's zero
            (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
            // is an Object and has no keys
            (value.constructor === Object && Object.keys(value).length === 0)
            )
        },
        async sendMobileNotification(){
            console.log("push Notif click");
            Swal.fire({
                title: 'Push Notification',
                html: `<input type="text" id="title" class="swal2-input" placeholder="Title">
                <input type="text" id="content" class="swal2-input" placeholder="Content">`,
                confirmButtonText: 'Push Notification',
                focusConfirm: false,
                preConfirm: () => {
                    const title = Swal.getPopup().querySelector('#title').value
                    const content = Swal.getPopup().querySelector('#content').value
                    if (!title || !content) {
                        Swal.showValidationMessage(`Please say something.`)
                    }
                    return { title: title, content: content }
                }
            }).then(async (result) => {
                await this.pushMobileNotification({
                    "title": result.value.title,
                    "to": this.subscriberDetails.businessId,
                    "content": result.value.content
                })
                .then(function(res){
                    console.log(">> push notification res:", res);
                })
                .catch(function(e){
                    console.log(">> push notification err:", e);
                })
                // Swal.fire(`
                //     Title: ${result.value.title}
                //     Content: ${result.value.content}
                // `.trim())
            })
        }
    },
    beforeRouteLeave(to, from, next) {
        console.log("><><><><> HEY",JSON.stringify(this.idDetails),JSON.stringify(this.formExitChecker));
        if (this.isUpdateKYC || this.haveKYC('status','manual')) {
            // if (!window.confirm("Are you sure you want to leave this page?")) {
            //     return;
            // }
            if(JSON.stringify(this.idDetails) != JSON.stringify(this.formExitChecker)){
                this.leaveform(next);
            }else{
                next();
            }
        }else{
            next();
        }
    }
};


</script>
<style>
    .last-div {
        border-bottom: 1px solid;
        margin-bottom: 15px
    }
    .fix-img {
        width: 96px;
        height: 96px;
        object-fit: cover;
    }
</style>
<template>
  <div>

    <div class="row">
      <div class="col-xl-3">
        <div class="card">
            <div class="card-body">
                <div class="avatar-xl mx-auto mb-4">
                <img
                    :src="userProfileImg"
                    alt=""
                    @error="(e) => e.target.src = require('@/assets/images/users/avatar-1.jpg')" 
                    class="rounded-circle img-thumbnail fix-img"
                />
                </div>
                <h5 class="mb-1 text-center text-capitalize" :title="subscriberDetails.subscriberName">{{subscriberDetails.subscriberName | truncator(20,'...')}}</h5>
                <button class="btn btn-sm btn-primary" @click="sendMobileNotification();" style="display:none;">test Nofication</button>
                <ul class="list-unstyled mb-0 mt-4">
                    <li class="pb-2">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-user-circle'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13 fw-semibold">Login Method</p>
                                <h5 class="mb-0 font-size-14 fw-normal">{{isEmpty(subscriberDetails.platform) ? '-':subscriberDetails.platform}}</h5>
                            </div>
                        </div>
                    </li>
                    <li class="pb-2">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-mobile-alt'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13 fw-semibold">Account Mobile Number</p>
                                <h5 class="mb-0 font-size-14 fw-normal">{{isEmpty(subscriberDetails.subscriberMobileNumber) ? '-':subscriberDetails.subscriberMobileNumber}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-envelope'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13 fw-semibold">Email</p>
                                <h5 class="mb-0 font-size-14 fw-normal">{{isEmpty(subscriberDetails.subscriberEmail)? '-':subscriberDetails.subscriberEmail}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-calendar-check'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13 fw-semibold">Registered Date </p>
                                <h5 class="mb-0 font-size-14 fw-normal">{{(isEmpty(subscriberDetails.registered)? '-':subscriberDetails.registered) | formatDateNoComma}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bxs-user-detail'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13 fw-semibold">Wallet Address </p>
                                <h5 class="mb-0 font-size-14 fw-normal">{{isEmpty(subscriberDetails.cogUserSub)? '-':subscriberDetails.cogUserSub}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='mdi mdi-wallet align-middle'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13 fw-semibold">E-load Wallet Balance </p>
                                <h5 class="mb-0 font-size-14 fw-normal">{{(isEmpty(subscriberDetails.balance)? 0:subscriberDetails.balance) | toCurrency}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                </ul>
            </div>
        </div>
        <!-- end card -->
        <div class="card" v-if="false">
          <div class="card-body">
            <div>
              <ul class="list-unstyled mb-0 text-muted">
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i class="mdi mdi-facebook font-size-16 text-blue me-1"></i>
                      Facebook
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Facebook}}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i
                        class="mdi mdi-twitter font-size-16 text-info me-1"
                      ></i>
                      Twitter
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Twitter}}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i
                        class="mdi mdi-instagram font-size-16 text-danger me-1"
                      ></i>
                      Instagram
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Instagram}}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i
                        class="mdi mdi-youtube font-size-16 text-danger me-1"
                      ></i>
                      Youtube
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Youtube}}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
            <div class="col-lg-12" v-if="verification && haveKYC()">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                            <div class="flex-grow-1 my-auto">
                                <span class="align-middle fw-semibold">KYC Details</span>
                            </div>
                            <div class="flex-shrink-0 my-auto">
                                <span v-if="haveKYC('status','manual')" class="badge rounded-pill bg-warning text-dark"><i class="mdi mdi-calendar-clock me-1"></i>Manual Verification</span>
                                <span v-if="haveKYC('status','verified')" class="badge rounded-pill bg-success text-dark"><i class="mdi mdi-calendar-clock me-1"></i>Verified</span>
                                <span v-if="haveKYC('status','reject')" class="badge rounded-pill bg-danger text-dark"><i class="mdi mdi-calendar-clock me-1"></i>Rejected</span>
                            </div>
                        </div>

                        <div class="row">
                            <form>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="row m-b-10">
                                            <div class="col"><p class="font-size-14 fw-semibold">First Name: </p></div>
                                            <div class="col"> 
                                                <input 
                                                    v-model="idDetails.firstName" 
                                                    class="form-control" 
                                                    placeholder="Juan"
                                                    type="text"
                                                    :class="{
                                                        'is-invalid' : isSubmitted && idDetailsValidation.firstName
                                                    }"/>
                                                <div
                                                    v-if="isSubmitted && idDetailsValidation.firstName"
                                                    class="invalid-feedback">
                                                    This value is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row m-b-10">
                                            <div class="col"><p class="font-size-14 fw-semibold">Middle Name: </p></div>
                                            <div class="col"> 
                                                <input 
                                                    v-model="idDetails.middleName" 
                                                    class="form-control" 
                                                    placeholder="Middle"
                                                    type="text"
                                                    :class="{
                                                        'is-invalid' : isSubmitted && idDetailsValidation.middleName
                                                    }"/>
                                                <div
                                                    v-if="isSubmitted && idDetailsValidation.middleName"
                                                    class="invalid-feedback">
                                                    This value is required. (Enter "N/A" if none)
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row m-b-10">
                                            <div class="col"><p class="font-size-14 fw-semibold">last Name: </p></div>
                                            <div class="col">
                                                <input 
                                                    v-model="idDetails.lastName" 
                                                    class="form-control" 
                                                    placeholder="Dela Cruz"
                                                    type="text"
                                                    :class="{
                                                        'is-invalid' : isSubmitted && idDetailsValidation.lastName
                                                    }"/>
                                                <div
                                                    v-if="isSubmitted && idDetailsValidation.lastName"
                                                    class="invalid-feedback">
                                                    This value is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row m-b-10">
                                            <div class="col"><p class="font-size-14 fw-semibold">ID Type: </p></div>
                                            <div class="col" v-if="!isUpdateKYC">
                                                <input 
                                                    v-model="idDetails.idType" 
                                                    class="form-control" 
                                                    placeholder="ID"
                                                    type="text"
                                                    :class="{
                                                        'is-invalid' : isSubmitted && idDetailsValidation.idType
                                                    }"/>
                                                <div
                                                    v-if="isSubmitted && idDetailsValidation.idType"
                                                    class="invalid-feedback">
                                                    This value is required.
                                                </div>
                                            </div>
                                            <div class="col" v-if="isUpdateKYC">
                                                <input 
                                                    v-model="idDetails.idType" 
                                                    class="form-control" 
                                                    placeholder="ID"
                                                    type="text" disabled/>
                                            </div>
                                        </div>
                                        <div class="row m-b-10">
                                            <div class="col"><p class="font-size-14 fw-semibold">ID Number: </p></div>
                                            <div class="col" v-if="!isUpdateKYC">
                                                <input 
                                                    v-model="idDetails.idNumber" 
                                                    class="form-control" 
                                                    placeholder="ID #"
                                                    type="text"
                                                    :class="{
                                                        'is-invalid' : isSubmitted && idDetailsValidation.idNumber
                                                    }"/>
                                                <div
                                                    v-if="isSubmitted && idDetailsValidation.idNumber"
                                                    class="invalid-feedback">
                                                    This value is required.
                                                </div>
                                            </div>
                                            <div class="col" v-if="isUpdateKYC">
                                                <input 
                                                    v-model="idDetails.idNumber" 
                                                    class="form-control" 
                                                    placeholder="ID #"
                                                    type="text" disabled>
                                            </div>
                                        </div>                                        
                                        <p class="font-size-14 fw-semibold" v-if="haveKYC('status','verified') && isUpdateKYC">Date Verified: <span class="fw-normal" v-if="haveKYC('result')">{{formatEpochDate(subscriberDetails.kyc_details.kyc_status.date_time) | formatDateNoComma}}</span></p>
                                    </div>

                                    <div class="col">
                                        <div class="pull-right" v-if="false">
                                            <button class="btn btn-primary btn-sm shadow-none me-2" type="button"  @click="verification = !verification">x</button>
                                        </div>
                                        <p class="font-size-14 fw-semibold">IDs</p>
                                        <ul class="ps-3 list-group list-group-horizontal">
                                            <li class="list-group-item">
                                                <a @click="isIDVisible = true; index = 0" class="pe-auto "  style="cursor: pointer" > Front ID</a>
                                            </li>   
                                            <li class="list-group-item">
                                                <a @click="isIDVisible = true; index = 1" class="pe-auto " style="cursor: pointer">Selfie</a>
                                            </li>       
                                        </ul>
                                        <br>

                                        <template v-if="!isUpdateKYC">
                                            <label for="textarea" class=" fw-semibold">Remarks:</label>
                                            <b-form-textarea
                                                id="textarea"
                                                placeholder="Enter remarks..."
                                                rows="2"
                                                max-rows="4"
                                                v-model="idDetails.desc"
                                                :class="{
                                                        'is-invalid' : isSubmitted && idDetailsValidation.desc
                                                    }"
                                            ></b-form-textarea>
                                            <div
                                                v-if="isSubmitted && idDetailsValidation.desc"
                                                class="invalid-feedback">
                                                This value is required.
                                            </div>
                                        </template>

                                        <template v-if="isUpdateKYC">
                                            <label for="textarea" class=" fw-semibold">Remarks:</label>
                                            <b-form-textarea
                                                id="textarea"
                                                placeholder="Enter remarks..."
                                                rows="2"
                                                max-rows="4"
                                                v-model="idDetails.desc"
                                                disabled
                                            ></b-form-textarea>
                                        </template>
                                    </div>
                                </div>
                                <div class="row d-flex" style="float:right" v-if="false"> <!-- hidden -->
                                    <label class="small fw-bold">Action: </label>

                                    <div class="d-flex">

                                        <button class="btn btn-warning btn-sm shadow-none me-2" type="button" @click="verifyKYC('reject')">REJECT</button>
                                        <button class="btn btn-primary btn-sm shadow-none me-2" type="button"  @click="verifyKYC('verified')">VERIFY</button>
                                    </div>
                                </div><!-- hidden -->
                            </form>
                            <vue-easy-lightbox
                                escDisabled
                                moveDisabled
                                :visible="isIDVisible"
                                :index="index"
                                :imgs="subscriberIDs"
                                @hide="isIDVisible = false"
                            ></vue-easy-lightbox>
                        </div>
                    </div>
                    <div class="card-footer card-footer-gray">
                        <div class="pull-right" v-if="!isUpdateKYC">
                            <button class="btn btn-warning btn-sm shadow-none me-2" type="button" @click="verifyKYC('reject')">REJECT</button>
                            <button class="btn btn-primary btn-sm shadow-none me-2" type="button"  @click="verifyKYC('verified')">VERIFY</button>
                        </div>
                        <div class="pull-right" v-if="isUpdateKYC">
                            <button class="btn btn-warning btn-sm shadow-none me-2" type="button"  @click="leaveform(null,true)">CANCEL</button>
                            <button class="btn btn-primary btn-sm shadow-none me-2" type="button"  @click="updateKYC()">UPDATE</button>
                        </div>
                        ACTION:
                    </div>
                </div>
                <!-- end card -->
            </div>
            <div class="col-lg-12" v-if="!verification && haveKYC()"><!-- display KYC -->
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                            <div class="flex-grow-1 my-auto">
                                <span class="align-middle fw-semibold">KYC Details</span>
                            </div>
                            <div class="flex-shrink-0 my-auto">
                                <span v-if="haveKYC('status','manual')" class="badge rounded-pill bg-warning text-dark"><i class="mdi mdi-calendar-clock me-1"></i>Manual Verification</span>
                                <span v-if="haveKYC('status','verified')" class="badge rounded-pill bg-success text-dark"><i class="mdi mdi-calendar-clock me-1"></i>Verified</span>
                                <span v-if="haveKYC('status','reject') || haveKYC('status','max-image')" class="badge rounded-pill bg-danger text-dark"><i class="mdi mdi-calendar-clock me-1"></i>Rejected</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <p class="font-size-14 fw-semibold">First Name: <span class="fw-normal" v-if="haveKYC('result')" :title="subscriberDetails.kyc_details.kyc_result.idDetails.firstName">{{subscriberDetails.kyc_details.kyc_result.idDetails.firstName | truncator(20,'...')}}</span></p>
                                <p class="font-size-14 fw-semibold">Middle Name: <span class="fw-normal" v-if="haveKYC('result')" :title="subscriberDetails.kyc_details.kyc_result.idDetails.middleName">{{subscriberDetails.kyc_details.kyc_result.idDetails.middleName | truncator(20,'...')}}</span></p>
                                <p class="font-size-14 fw-semibold">Last Name: <span class="fw-normal" v-if="haveKYC('result')" :title="subscriberDetails.kyc_details.kyc_result.idDetails.lastName">{{subscriberDetails.kyc_details.kyc_result.idDetails.lastName | truncator(20,'...')}} </span></p>
                                <p class="font-size-14 fw-semibold">ID Type: <span class="fw-normal" v-if="haveKYC('result')">{{subscriberDetails.kyc_details.kyc_result.idDetails.idType}}</span></p>
                                <p class="font-size-14 fw-semibold">ID Number: <span class="fw-normal" v-if="haveKYC('result')">{{subscriberDetails.kyc_details.kyc_result.idDetails.hasOwnProperty('idNumber')? subscriberDetails.kyc_details.kyc_result.idDetails.idNumber :' - '}}</span></p>
                                <p class="font-size-14 fw-semibold" v-if="haveKYC('status','verified')">Date Verified: <span class="fw-normal" v-if="haveKYC('result')">{{formatEpochDate(subscriberDetails.kyc_details.kyc_status.date_time) | formatDateNoComma}}</span></p>
                                <p class="font-size-14 fw-semibold" v-if="false">Description: <span class="fw-normal" v-if="haveKYC('result')">{{subscriberDetails.kyc_details.kyc_status.description}}</span></p>
                            </div>

                            <div class="col">
                                <div class="pull-right">
                                    <button class="btn btn-primary btn-sm shadow-none me-2" type="button" v-if="haveKYC('status','verified')"  @click="evaluateKyc(true);"><i class='bx bx-pencil'></i></button>
                                </div>
                                <p class="font-size-14 fw-semibold">IDs</p>
                                <ul class="ps-3 list-group list-group-horizontal">
                                    <li class="list-group-item">
                                        <a class="pe-auto " @click="isIDVisible = true; index = 0" style="cursor: pointer" > Front ID</a>
                                    </li>   
                                    <li class="list-group-item">
                                        <a class="pe-auto " @click="isIDVisible = true; index = 1" style="cursor: pointer">Selfie</a>
                                    </li>       
                                </ul>
                                <br>                                
                                <p class="font-size-14 fw-semibold" v-if="false">Remarks: <span class="fw-normal" v-if="haveKYC('result')">{{subscriberDetails.kyc_details.kyc_status.description}}</span></p>
                                <div>
                                    <label for="textarea">Remarks:</label>
                                    <b-form-textarea
                                        id="textarea"
                                        placeholder="Enter remarks..."
                                        rows="2"
                                        max-rows="4" 
                                        v-if="subscriberDetails.kyc_details.kyc_status.hasOwnProperty('description')"
                                        v-model="subscriberDetails.kyc_details.kyc_status.description" disabled
                                    ></b-form-textarea>
                                    <b-form-textarea
                                        id="textarea"
                                        placeholder="Enter remarks..."
                                        rows="2"
                                        max-rows="4" 
                                        v-if="subscriberDetails.kyc_details.kyc_status.hasOwnProperty('remarks')"
                                        v-model="subscriberDetails.kyc_details.kyc_status.remarks" disabled
                                    ></b-form-textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex" style="float:right" v-if="haveKYC('status','manual') && false">
                            <label class="small fw-bold">Action: </label>
                            <div class="d-flex">
                                <button class="btn btn-primary btn-sm shadow-none me-2" type="button"  @click="verification = !verification">VERIFY</button>
                            </div>
                        </div>
                        <vue-easy-lightbox
                            escDisabled
                            moveDisabled
                            :visible="isIDVisible"
                            :index="index"
                            :imgs="subscriberIDs"
                            @hide="isIDVisible = false"
                        ></vue-easy-lightbox>
                    </div>
                    <div class="card-footer card-footer-gray" v-if="haveKYC('status','manual')">
                        <div class="pull-right">
                            <button class="btn btn-primary btn-sm shadow-none me-2" v-if="false" type="button"  @click="verification = !verification; evaluateKyc();">EVALUATE</button>
                        </div>
                        ACTION:
                    </div>
                    <div class="card-footer card-footer-gray" v-if="!haveKYC('status','manual')">
                        <div class="pull-right">
                            <button class="btn btn-primary btn-sm shadow-none me-2" type="button" @click="showCreateModalFunction();showCreateModal = true">VIEW HISTORY</button>
                        </div>
                        ACTION:
                    </div>
                </div>
                <!-- end card -->
                <!-- create promo modal -->
                <b-modal id="bv-modal-kyc-history" title="HISTORY LOGS" size="md" centered hide-footer hide-header-close>
                    <div class="row modal-h-400" v-if="subscriberDetails.kyc_details.hasOwnProperty('kyc_history')">
                        <div class="col-sm-12" v-for="(data,data_index) in subscriberDetails.kyc_details.kyc_history" :key="data_index" v-bind:todo="data">
                            <p class="font-size-14 text-uppercase m-b-0">Action: <span class="fw-semibold">{{data.action}}</span></p>
                            <div v-if="data.action == 'upload' || data.action == 're-upload'">
                                <p class="font-size-14 m-b-0">Date: <span class="fw-semibold">{{data.date | convertTimestamp | formatDateNoComma}}</span></p>
                                <p class="font-size-14 m-b-0" v-if="false">ID: <span class="fw-semibold">{{data.id_card}}</span></p>
                                <p class="font-size-14" v-if="false">Selfie: <span class="fw-semibold">{{data.selfie}}</span></p>
                                <p class="font-size-14 m-b-0">IDs</p>
                                <ul class="ps-3 list-group list-group-horizontal m-b-15">
                                    <li class="list-group-item">
                                        <a class="pe-auto " @click="isIDVisible = true; index = data.id_index" style="cursor: pointer" > Front ID</a>
                                    </li>   
                                    <li class="list-group-item">
                                        <a class="pe-auto " @click="isIDVisible = true; index = data.selfie_index" style="cursor: pointer">Selfie</a>
                                    </li>       
                                </ul>
                            </div>
                            <div v-if="data.action == 'manual'">
                                <p class="font-size-14 m-b-0">Date: <span class="fw-semibold">{{data.date | convertTimestamp | formatDateNoComma}}</span></p>
                                <p class="font-size-14">Remarks: <span class="fw-semibold">{{data.remarks}}</span></p>
                            </div>
                            <div v-if="data.action == 'reject' || data.action == 'verified'" class="last-div">
                                <p class="font-size-14 m-b-0">Date: <span class="fw-semibold">{{data.date | convertTimestamp | formatDateNoComma}}</span></p>
                                <p class="font-size-14 m-b-0 text-capitalize">{{data.action}} By: <span class="fw-semibold">{{data.approver}}</span></p>
                                <p class="font-size-14">Remarks: <span class="fw-semibold">{{data.remarks}}</span></p>
                            </div>
                            <div v-if="data.action == 'UPDATE'">
                                <p class="font-size-14 m-b-0">Date: <span class="fw-semibold">{{data.date | convertTimestamp | formatDateNoComma}}</span></p>
                                <p class="font-size-14 m-b-0 text-capitalize">{{data.action}} By: <span class="fw-semibold">{{data.approver}}</span></p>
                                <p class="font-size-14">Remarks: <span class="fw-semibold">{{data.remarks}}</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="row modal-h-400" v-if="!subscriberDetails.kyc_details.hasOwnProperty('kyc_history')">
                        <p>No History Logs.</p>
                    </div>
                    <div class="text-end mt-3">
                        <b-button variant="light" class="w-sm" @click="closeModal('bv-modal-kyc-history')">Close</b-button>
                    </div>
                </b-modal>
            </div><!-- end of display KYC -->

            <div class="col-lg-12" v-if="!haveKYC()"><!-- display NO KYC -->
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                            <div class="flex-grow-1 my-auto">
                                <span class="align-middle fw-semibold">KYC Details</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-center">
                                <h6 style="margin:10% 0px;">Don't have KYC</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer card-footer-gray">
                        &nbsp;
                    </div>
                </div>
                <!-- end card -->
            </div><!-- end of display KYC -->

            <div class="col-lg-12" v-if="false">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                            <div class="flex-grow-1 my-auto">
                                <span class="align-middle">Business Information</span>
                            </div>
                            <div class="flex-shrink-0 my-auto">
                                <router-link  class="small fw-semibold" :to="{ name: 'Business Detail', params: { id: subscriberDetails.businessId || 0 }}" >View</router-link>
                            </div>
                        </div>
                        <ul class="list-unstyled mb-0">
                            <!-- end li -->
                            <li class="pb-3">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                        <i class='bx bx-store-alt'></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <p class="mb-1 font-size-13">Business Name</p>
                                        <h5 class="mb-0 font-size-14">{{subscriberDetails.businessName}}</h5>
                                    </div>
                                </div>
                            </li>
                            <!-- end li -->
                            <li class="py-3">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                        <i class='bx bx-phone'></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <p class="mb-1 font-size-13">Business Number</p>
                                        <h5 class="mb-0 font-size-14">{{subscriberDetails.subscriberMobileNumber}}</h5>
                                    </div>
                                </div>
                            </li>
                            <!-- end li -->
                            <li class="py-3">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                        <i class='bx bx-time-five'></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <p class="mb-1 font-size-13">Business Hours</p>
                                        <h5 class="mb-0 font-size-14">{{subscriberDetails.businessHours}}</h5>
                                    </div>
                                </div>
                            </li>
                            <!-- end li -->
                            <li class="py-3">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                        <i class='bx bx-map'></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <p class="mb-1 font-size-13">Business Location</p>
                                        <h5 class="mb-0 font-size-14">{{subscriberDetails.businessLocation}}</h5>
                                    </div>
                                </div>
                            </li>
                            <!-- end li -->
                            <li class="py-3">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                        <i class='bx bx-map-pin'></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <p class="mb-1 font-size-13">Business Address</p>
                                        <h5 class="mb-0 font-size-14">{{subscriberDetails.businessAddress}}</h5>
                                    </div>
                                </div>
                            </li>
                            <!-- end li -->
                        </ul>
                    </div>
                <!-- end card body -->
                </div>
                <!-- end card -->
            </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>

</template>
